import { APIExtRoutes } from "@constants/routes";
import { APIResponse, S3ObjectDTO } from "@models/core";
import { APIGatewayFileUploadService, APIGatewayService, handleErrorProxy } from "@services/shService";

export async function uploadAvatar(
  file?: FormData,
): Promise<APIResponse<S3ObjectDTO>> {
  const response = await APIGatewayFileUploadService.post<S3ObjectDTO>(
    APIExtRoutes.uploadPublic,
    file,
  );

  return handleErrorProxy(response);
}

export async function deleteAvatar(
  s3Key?: string,
): Promise<APIResponse<APIResponse>> {
  const response = await APIGatewayService.delete<APIResponse>(
    `${APIExtRoutes.deletePublic}/${s3Key}`,
  );

  return handleErrorProxy(response);
}
